/**
 * Adzuki. My Settings
 *
 * SET-8: the My Settings modal - overlay, dismissal and viewport sizing.
 *
 * HOSTED IN-PAGE, NOT IN AN IFRAME AND NOT IN A NEW TAB (S31). The overlay is built in the
 * CP|central document that is already on screen and the panel arrives as an HTML fragment, so
 * dirty tracking, the leave guard and route changes are all internal calls rather than a
 * postMessage protocol.
 *
 * WHAT THIS FILE DOES NOT OWN:
 *
 *   the header bar past the X, the left nav and deep linking  SET-9
 *   the discard-confirmation dialog                           SET-76 - see registerGuard()
 *   the Save button, save status and dirty tracking            SET-12, SET-74, SET-75
 *   the dark theme                                             SET-15
 *   focus ring styling                                         SET-105
 *
 * Every one of those has a named seam here rather than a stub, so landing them does not mean
 * rewriting this.
 */

(function MySettings($, Adzuki)
{
	"use strict";

	var LOCK_CLASS = 'my-settings-locked',
	    BG_MARK    = 'data-my-settings-bg-hidden',
	    FOCUSABLE  = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

	var settings   = {},
	    $overlay   = null,
	    $opener    = null,
	    guard      = null,
	    panel_url  = null,
	    scroll_top = 0,
	    nav_scroll = 0,
	    panel_scroll = null;

	var _lock,
	    _unlock,
	    _bind,
	    _fetch,
	    _afterRender,
	    _swapPanel,
	    _navIsOpen,
	    _setNavOpen,
	    _partialMessage,
	    _placeFieldTooltips,
	    _sizeTextareas,
	    _errorMarkup,
	    _escape,
	    _resolve,
	    _trapTab,
	    _hideBackground,
	    _showBackground,
	    _restoreFocus,
	    _installRedirectSeam,
	    _installErrorCopySeam,
	    _showPane,
	    _reloadIfShellChanged;

	// the framework's own throwSubmissionError, kept so the seam below can hand every save
	// outside the modal straight back to it and so close() can put it back untouched
	var _frameworkThrowSubmissionError = null;

	/**
	 * Stops the CP|central page behind the modal from scrolling.
	 *
	 * THE CLASS GOES ON <body>, NOT ON <html>, AND THAT IS THE WHOLE FIX FOR THE JUMP.
	 * Setting overflow: hidden on the root element makes the document unscrollable, and the
	 * browser then clamps the scroll offset to zero - so opening the modal threw the page
	 * behind it to the top and closing it jumped back down. On <body> the UA propagates the
	 * overflow to the viewport instead of re-anchoring it, so nothing moves. This is what
	 * Bootstrap's own body.modal-open has always done here.
	 *
	 * The scrollbar is compensated on <body> so that hiding it does not shift the page a
	 * scrollbar's width to the right behind the backdrop.
	 *
	 * The offset is still recorded and restored: it should now be a no-op, and it is kept as
	 * the safety net for any engine that does re-anchor, because AC 10 says the advisor comes
	 * back exactly where they left off.
	 */
	_lock = function lock()
	{
		var bar_width = window.innerWidth - document.documentElement.clientWidth;

		scroll_top = $(window).scrollTop();

		$('body').addClass(LOCK_CLASS);

		if (bar_width > 0) {
			$('body').css('padding-right', bar_width + 'px');
		}
	};

	_unlock = function unlock()
	{
		$('body').removeClass(LOCK_CLASS);
		$('body').css('padding-right', '');

		$(window).scrollTop(scroll_top);
	};

	/**
	 * SET-148 QA ROUND 3: TAKES THE PAGE BEHIND THE MODAL OUT OF THE ACCESSIBILITY TREE.
	 *
	 * The dialog has carried aria-modal="true" since SET-8, and by the specification that is the
	 * whole answer - everything outside the dialog is hidden from assistive technology for as
	 * long as it is open. NARRATOR DOES NOT HONOUR IT IN SCAN MODE. QA read straight out of the
	 * bottom of the modal and on into "CP Maxx document... banner landmark, navigation landmark,
	 * link CP MAXX": the CP|central page underneath, which the advisor cannot see and must not be
	 * able to operate.
	 *
	 * NOTHING ELSE WAS EVER GOING TO CATCH IT. The backdrop stops the mouse, _lock() stops the
	 * scroll and _trapTab() stops Tab - three defences that each assume the advisor is driving
	 * through a pointer or the tab order. A reader's virtual cursor uses neither.
	 *
	 * BOTH ATTRIBUTES, because they answer different halves. aria-hidden removes the subtree from
	 * the accessibility tree, which is the reported defect. `inert` additionally removes it from
	 * the tab order and from hit testing, which demotes the Tab trap from the only line of
	 * defence to the second one. A browser without `inert` ignores the attribute and keeps
	 * exactly the behaviour it has today, so it costs nothing to send both.
	 *
	 * MARKED AT OPEN TIME RATHER THAN MATCHED BY A SELECTOR, and that is load-bearing: only the
	 * body children that exist WHEN THE MODAL OPENS are background. Anything appended to <body>
	 * afterwards belongs to the modal's own interactions - a jQuery-confirm prompt from the
	 * Shortcuts list, a bootstrap tooltip with a body container, a datepicker - and hiding those
	 * would silence the modal instead of the page.
	 *
	 * A node that already calls itself hidden is left alone AND LEFT UNMARKED, so the restore
	 * cannot hand back a state the page never had.
	 *
	 * Runs BEFORE the overlay is appended, which is why nothing here has to exclude it.
	 */
	_hideBackground = function hideBackground()
	{
		$('body').children().each(function markOne() {
			var $node = $(this);

			// SET-180: #modalWindow IS NOT BACKGROUND, and it is a direct child of <body> in all 17
			// layouts that declare it - so this loop reached it and the framework's one shared dialog
			// went inert the moment the modal opened. Every dialog a panel opens lands there: a
			// login-as prompt from the Franchise Profile owner list, an MFA confirm, a datepicker.
			// They were painted on top at z-index 1080 by the rule _my_settings.scss already carries
			// for exactly this reason, and they ignored every click.
			//
			// INERT CANNOT BE UNDONE FROM INSIDE THE SUBTREE. It is inherited and there is no
			// inert="false", so nothing .modal('show') does can recover it; the only place to fix
			// this is here, before it is ever set.
			//
			// SKIPPING IT DOES NOT REOPEN SET-148. While no dialog is showing #modalWindow is
			// display:none, so it is out of the accessibility tree whether or not it carries
			// aria-hidden - which is the half worth keeping in mind before this looks removable.
			if ($node.is('#modalWindow')) {
				return;
			}

			if ($node.attr('aria-hidden') === 'true' || $node.is('[inert]')) {
				return;
			}

			$node.attr('aria-hidden', 'true').attr('inert', 'inert').attr(BG_MARK, '1');
		});
	};

	/**
	 * SET-148 QA ROUND 4: RETURNS FOCUS TO WHATEVER OPENED THE MODAL, AND CHECKS THAT IT LANDED.
	 *
	 * $opener.focus() was called and never verified, and on the CP|central header it cannot work:
	 * the entry point is an <a> inside <ul class="dropdown-menu">, and Bootstrap closes that menu
	 * the moment the item is clicked. AN ELEMENT INSIDE A display:none SUBTREE CANNOT TAKE FOCUS,
	 * so the call is a silent no-op and focus is left on <body> - outside everything, which is
	 * what QA heard as "CP Maxx - Google Chrome window, CP Maxx".
	 *
	 * THE SAME FAILURE AS SET-149'S DRAWER, one ticket apart: a focus call that cannot land, that
	 * reports nothing, and that nobody checked. The lesson there was to make the element
	 * focusable; here the element is gone from view entirely and should not be brought back, so
	 * the answer is to verify and fall back.
	 *
	 * THE FALLBACK IS THE DROPDOWN'S OWN TOGGLE, which is the right destination rather than a
	 * consolation prize: it is the control that leads back to the item, it is visible, and it is
	 * where a keyboard user would expect to be after a menu closed behind them.
	 *
	 * document.activeElement is read back rather than assumed. A focus() that fails throws
	 * nothing and returns nothing, so the only way to know is to look - which is the whole
	 * recurring lesson of this ticket.
	 *
	 * @param  object $opener_el jQuery element that opened the modal.
	 *
	 * @return boolean Whether anything actually took focus.
	 */
	_restoreFocus = function restoreFocus($opener_el)
	{
		var tries = [$opener_el],
		    $menu = $opener_el.closest('.dropdown-menu'),
		    $try,
		    i;

		if ($menu.length) {
			tries.push($menu.parent().find('[data-toggle="dropdown"]').first());
		}

		for (i = 0; i < tries.length; i++) {
			$try = tries[i];

			if (!$try || !$try.length) {
				continue;
			}

			$try.focus();

			if (document.activeElement === $try[0]) {
				return true;
			}
		}

		return false;
	};

	/**
	 * Hands the page back.
	 *
	 * HAS TO RUN BEFORE FOCUS RETURNS TO WHATEVER OPENED THE MODAL. An inert element cannot take
	 * focus, so restoring after close()'s $opener.focus() would silently drop the advisor on
	 * <body> every single time - the same fall-out-of-the-dialog this ticket has now fixed twice
	 * elsewhere.
	 */
	_showBackground = function showBackground()
	{
		$('body').children('[' + BG_MARK + ']')
			.removeAttr('aria-hidden')
			.removeAttr('inert')
			.removeAttr(BG_MARK);
	};

	/**
	 * Everything that can dismiss the modal, and the containment that keeps it alive.
	 */
	_bind = function bind()
	{
		// clicking outside the modal. mousedown rather than click, and only when the press
		// both started and landed on the backdrop itself - otherwise a drag that begins on a
		// control inside the panel and releases past its edge reads as "clicked outside" and
		// throws the advisor out mid-gesture.
		$overlay.on('mousedown', function backdropPress(e) {
			if (e.target === e.currentTarget) {
				settings.requestClose('backdrop');
			}
		});

		$overlay.on('click', '[data-my-settings-close]', function closeButton(e) {
			e.preventDefault();

			settings.requestClose('button');
		});

		// CONTAINMENT, not navigation. A link inside the modal pointing at another panel
		// would otherwise navigate the whole host page away - taking the modal, the page
		// behind it and any work in progress with it. Panel routing, deep links and the
		// left-nav subsection links are SET-9's; this only keeps an in-modal link from
		// destroying its own host.
		// NOT A LINK THAT ASKS FOR A NEW TAB. This selector used to capture every /MySettings/
		// href unconditionally, which meant a panel action serving a FILE - the 1099 PDF - was
		// fetched as a panel and rendered into the overlay instead of downloading. A link
		// carrying `target` has said where it wants to go, so it is left alone.
		// SET-149: THE NAV DRAWER, below 900px where the two-column shell no longer fits.
		//
		// The state is a class on the shell, and the shell is inside the markup $overlay.html()
		// replaces on every render - so CHOOSING A SECTION CLOSES THE DRAWER FOR FREE, with
		// nothing to remember to do. The only paths that need handling are the ones that do not
		// navigate: the toggle, the scrim and ESC.
		//
		// Delegated from $overlay rather than bound to the button, because the button is one of
		// the elements being replaced each time.
		$overlay.on('click', '[data-my-settings-nav-toggle]', function navToggle() {
			_setNavOpen(!_navIsOpen());
		});

		$overlay.on('click', '[data-my-settings-nav-close]', function navScrim() {
			_setNavOpen(false);
		});

		$overlay.on('click', 'a[href*="/MySettings/"]:not([target])', function panelLink(e) {
			e.preventDefault();

			settings.requestNavigate($(this).attr('href'));
		});

		// SET-123: a tab backed by the same form as the one on screen switches PANES rather
		// than fetching a panel, and it does NOT ask the guard.
		//
		// Both halves matter. It cannot fetch, because the sibling pane's fields are in this
		// form and a fetch would replace them with server state - losing edits the advisor
		// made on a tab they are not looking at, and then posting only one pane's fields. And
		// it must not guard, because nothing is being left behind: S16 guards what leaves the
		// form, and this stays inside it.
		$overlay.on('click', '[data-my-settings-pane]', function paneTab(e) {
			e.preventDefault();

			_showPane($(this).attr('data-my-settings-pane'));
		});

		$overlay.on('keydown', function overlayKeys(e) {
			if (e.which === 9) {
				_trapTab(e);
			}
		});
	};

	/**
	 * Keeps Tab inside the modal.
	 *
	 * Without this, tabbing past the last control walks into the page behind the backdrop -
	 * which is inert to the mouse but perfectly reachable by keyboard, so a keyboard user ends
	 * up operating a page they cannot see.
	 */
	_trapTab = function trapTab(e)
	{
		var $focusable = $overlay.find(FOCUSABLE).filter(':visible'),
		    $first,
		    $last;

		// SET-180: WHILE A DIALOG IS OPEN IT OWNS FOCUS, NOT THIS.
		//
		// This keydown is bound on $overlay, so a key pressed inside #modalWindow never arrives
		// here at all - the dialog is a SIBLING of the overlay, not a descendant, so the event
		// does not bubble through it. What this guard covers is the other order: focus still in
		// the overlay with the dialog already open, where wrapping $last round to $first would
		// hold the advisor inside a surface the dialog is meant to have taken over.
		//
		// Bootstrap's own enforceFocus() is the containment in play once a dialog is up, and two
		// focus managers pulling at the same time is how a focus fight starts. One owner at a time.
		if ($('#modalWindow').hasClass('in')) {
			return;
		}

		if ($focusable.length === 0) {
			return;
		}

		$first = $focusable.first();
		$last  = $focusable.last();

		if (e.shiftKey && (e.target === $first[0] || $.contains($overlay[0], e.target) === false)) {
			e.preventDefault();
			$last.focus();
		} else if (!e.shiftKey && e.target === $last[0]) {
			e.preventDefault();
			$first.focus();
		}
	};

	/**
	 * An error state that hides the status is a defect of its own - the first time this fired,
	 * the message read the same whether the panel 404'd, the session had gone or the response
	 * never arrived at all, which helps neither the person reading it nor the next person
	 * debugging it. The console line carries the rest.
	 */
	_escape = function escape(text)
	{
		return $('<div>').text(text === null || text === undefined ? '' : text).html();
	};

	/**
	 * SET-10 QA ROUND 2: A REFUSAL IS NOT A FAILURE, AND IT MUST NOT READ LIKE ONE.
	 *
	 * A gated advisor - password expired or compromised, MFA unconfirmed, security training due,
	 * an assistant who has not impersonated, a silent owner - gets 403 from
	 * CpcentralApp::_refuseGatedRequest(), which sends a JSON body carrying BOTH the reason and
	 * the url of the screen they have to deal with first.
	 *
	 * THIS FUNCTION THREW BOTH AWAY and showed the generic failure: "could not be loaded just now
	 * - the server answered 403", offering "Open them on their own page instead" and "try again".
	 * Every part of that is wrong for a refusal. Trying again will never work; the panel's own page
	 * is refused by the same gate, so that link does nothing, which is what QA saw; and the advisor
	 * is told the system broke when in fact it is waiting on them.
	 *
	 * QA ROUND 3: BOTH BRANCHES NOW CARRY AN ACCESSIBLE NAME. This markup replaces the whole
	 * overlay, so it really is a new role="dialog" and a reader really has just entered one - and
	 * an unnamed dialog is announced as nothing but "dialog", which tells the advisor they have
	 * arrived somewhere without saying where. The name is the only part that differs between the
	 * two: a refusal is waiting on the advisor, a failure is not, and calling them both an error
	 * would undo the distinction the rest of this function exists to draw.
	 *
	 * aria-label RATHER THAN A HEADING, deliberately. A heading here would be the natural way to
	 * name it, and it would also take the landing focus - which would leave _afterRender()'s "no
	 * heading, fall back to the dialog container" branch with no caller again, exactly the dead
	 * path round two had to find the hard way.
	 */
	_errorMarkup = function errorMarkup(url, jq_xhr)
	{
		var status  = ((jq_xhr && jq_xhr.status) ? jq_xhr.status : 0),
		    refused = null,
		    detail;

		if (status === 403) {
			// responseJSON is absent when the body did not parse - a debug footer appended to it, say
			refused = ((jq_xhr && jq_xhr.responseJSON) ? jq_xhr.responseJSON : null);

			if (refused === null && jq_xhr && jq_xhr.responseText) {
				try {
					refused = JSON.parse(jq_xhr.responseText);
				} catch (e) {
					refused = null;
				}
			}
		}

		if (refused && refused.redirect) {
			// NO "try again" AND NO LINK TO THE PANEL. One way out, and it is the screen the gate
			// named - a full page load, so the gate lets it through rather than refusing it again.
			return '<div class="my-settings-modal my-settings-modal-error" role="dialog" aria-modal="true"'
				+ ' aria-label="Action needed" tabindex="-1">'
				+ '<p>' + _escape(refused.message || 'Finish what CP|central is asking you for before changing your settings.') + '</p>'
				+ '<p><a href="' + _escape(refused.redirect) + '">Take me there</a>'
				+ ' or <button type="button" class="btn btn-link" data-my-settings-close="1">close this</button>.</p>'
				+ '</div>';
		}

		detail = ((status === 0) ? 'the request did not complete' : 'the server answered ' + status);

		return '<div class="my-settings-modal my-settings-modal-error" role="dialog" aria-modal="true"'
			+ ' aria-label="Settings could not be loaded" tabindex="-1">'
			+ '<p>Your settings could not be loaded just now &mdash; ' + detail + '.</p>'
			+ '<p><a href="' + _resolve(url) + '">Open them on their own page instead</a>'
			+ ' or <button type="button" class="btn btn-link" data-my-settings-close="1">close this</button> and try again.</p>'
			+ '</div>';
	};

	/**
	 * Puts the app's base uri on a panel path, once.
	 *
	 * The app is not served from the domain root - it sits under /<user>/adzuki on dev -
	 * and the two sources of panel urls disagree about whether that prefix is already
	 * there. HtmlComponent::link() prefixes baseUri onto the HREF it builds, so an
	 * in-modal tab link arrives complete; but it emits the parameters it is handed
	 * verbatim, so data-my-settings arrives as a bare /MySettings/... path. Prefixing
	 * blindly would double the base on one and fetching blindly would drop it from the
	 * other, so both go through here.
	 */
	_resolve = function resolve(url)
	{
		var base = (Adzuki.base_uri || '');

		if (base === '' || url.indexOf('http') === 0 || url.indexOf(base + '/') === 0) {
			return url;
		}

		return base + url;
	};

	/**
	 * Fetches a panel and puts it in the overlay.
	 *
	 * The request is an AJAX GET, which is what tells MySettingsController to return the
	 * modal's interior rather than a whole page.
	 *
	 * THE "THIS IS THE OPEN" SIGNAL IS A HEADER, NOT A QUERY PARAMETER. requestData['get'] in
	 * this framework is not $_GET - it starts as array() and is filled from path segments
	 * (hardcore.php:266 and 315), so ?ms_open=1 put nothing in it and reading the key raised a
	 * notice under error_reporting(E_ALL), which failed the only request that carried it. A
	 * header is also how isAjax() works here, and it keeps panel urls clean - they are the
	 * same urls SET-10 will deep-link to.
	 *
	 * It rides only the fetch that opens the modal: it starts the shell-dirty session, and
	 * sending it on panel navigation would clear a flag set on an earlier panel - exactly the
	 * per-panel behaviour S37 rules out.
	 */
	_fetch = function fetch(url, is_open, fallback_url)
	{
		var headers = {};

		if (is_open) {
			headers['X-My-Settings-Open'] = '1';
		}

		$.ajax({
			url     : _resolve(url),
			type    : 'GET',
			headers : headers,
			dataType: 'html',
			success : function fetched(html) {
				if ($overlay === null) {
					return;
				}

				panel_url = url;

				// SET-10: READ THE NAV'S SCROLL BEFORE THE SWAP, because the swap is what loses it.
				// The response is the whole overlay, nav included, so every panel navigation
				// rebuilt the nav from scratch and it came back at the top - clicking a section
				// near the bottom of a tall nav scrolled the advisor's own click target out of
				// view. Unlike the panel body this is not conditional on keep_scroll: that flag is
				// about where the PANEL starts, and the nav is chrome the advisor is reading
				// against, not content they navigated to.
				//
				// On the opening fetch the overlay still holds the loading placeholder, so there is
				// no .my-settings-nav-scroll to find and this is 0 - which is also the right value
				// for a modal that has just opened.
				nav_scroll = $overlay.find('.my-settings-nav-scroll').scrollTop() || 0;

				_swapPanel(html);

				_afterRender();
			},
			error: function failed(jq_xhr, text_status, error_thrown) {
				if (window.console && console.error) {
					console.error('My Settings: panel fetch failed', {
						url        : _resolve(url),
						status     : jq_xhr.status,
						statusText : jq_xhr.statusText,
						textStatus : text_status,
						errorThrown: error_thrown,
						contentType: jq_xhr.getResponseHeader('Content-Type'),
						bodyStart  : (jq_xhr.responseText || '').substring(0, 300)
					});
				}

				if ($overlay === null) {
					return;
				}

				// SET-165: A FRAGMENT NAMES AN UNTRUSTED PANEL, so one retry at a known-good one
				// beats an error the advisor cannot act on. my_settings_route.js reads
				// #/MySettings/<panel> off the address bar and anyone can type one - a retired
				// panel (this ticket retired Cruise Planners Mobile), a renamed one, or a typo.
				// The framework answers a missing action with E_USER_ERROR and hardcore.php's
				// errorHandler() turns that into a 404 or a 500, so it arrives HERE rather than
				// in success() - which is what makes this the seam rather than the router.
				//
				// ONLY THE FRAGMENT PATH PASSES ONE. A panel the advisor reached by clicking a
				// nav link that then fails is a real failure and must still say so; this is not a
				// blanket retry.
				//
				// THE RETRY CARRIES is_open AND NO FALLBACK OF ITS OWN, so the modal session still
				// begins on the fetch that opens it, and a second failure shows the error rather
				// than looping.
				if (fallback_url) {
					_fetch(fallback_url, is_open);

					return;
				}

				$overlay.html(_errorMarkup(url, jq_xhr));

				// SET-148 AC 9: THE ERROR RENDER GETS THE SAME AFTER-RENDER PASS AS A PANEL.
				// Leaving it out did not merely skip a focus call - it trapped the advisor.
				//
				// _afterRender() already names THIS markup as the case its "no heading, fall back
				// to the dialog container" branch exists for. It was never called here, so that
				// fallback had never once run, and two things followed:
				//
				//   FOCUS FELL OUT OF THE DIALOG. The swap destroys whatever held focus and nothing
				//   put it back, so it landed on <body> - QA caught document.activeElement as
				//   BODY.my-settings-locked.
				//
				//   THE DESTROYED PANEL STAYED DIRTY, which is what actually trapped them.
				//   'my-settings:rendered' is what re-snapshots the save module's entry state, so
				//   without it the snapshot of the panel that had just been destroyed survived.
				//   _isDirty() counts a control present at entry and absent now as a change, and
				//   EVERY control is absent from the error markup - so it answered true whatever the
				//   advisor had or had not typed. requestClose() asked the guard, the guard opened
				//   the discard dialog, and that dialog is panel markup that no longer exists:
				//   .my-settings-guard matched nothing, so it drew nothing and returned false. ESC
				//   and the error box's own "close this" button both ran that path and both did
				//   nothing at all, leaving a page reload as the only way out.
				_afterRender();
			}
		});
	};

	/**
	 * SET-32: sizes any autoheight textarea inside the given scope.
	 *
	 * _global.js initialises textarea.autoheight once, at document ready, so a textarea that
	 * arrives with a panel never gets it.
	 *
	 * CALLED ON PANE SWITCH AS WELL AS ON RENDER, and that is the half that is easy to miss. A
	 * form group renders every pane at once and hides all but one, and a textarea in a display:none
	 * pane has a scrollHeight of ZERO - so measuring it at render time locks it at the helper's
	 * 50px default, and it only springs to the right height when the advisor types into it.
	 *
	 * MEASURED FROM NOTHING, NOT FROM THE CURRENT HEIGHT - the same correction SET-125 made to
	 * form.js's own resizer. scrollHeight can never report less than clientHeight, so a textarea
	 * that arrives taller than its content would otherwise keep that height for good.
	 *
	 * @param  object $scope jQuery element to search within.
	 *
	 * @return void
	 */
	/**
	 * SET-41: TOOLTIPS ON A FULL-WIDTH FIELD OPEN LEFT, OR THEY OPEN OFF THE PANEL.
	 *
	 * _global.js delegates tooltips from <body> with a selector and passes no placement, so
	 * bootstrap uses its default of 'top' and inserts the tooltip NEXT TO THE ELEMENT - inside the
	 * scrolling panel, which clips it. On a toggle the icon follows a few words and there is room;
	 * on a labelled field the icon is an .input-group addon on the right-hand end of a 720px input,
	 * hard against the panel's edge, and the tooltip is cut off.
	 *
	 * data-placement IS READ AT SHOW TIME, per element, even under a delegated init - so the
	 * attribute is all that is needed and _global.js is left alone. Doing it here rather than in
	 * AgentsSettingsForm matters: that form also backs the 143-field legacy screen, where the
	 * fields are not in a narrow panel and 'left' would be the wrong answer.
	 *
	 * EVERY KIND OF FIELD ROW, corrected twice. This first shipped scoped to
	 * .my-settings-field-control only, on the reasoning that a toggle's icon follows a few words
	 * and is nowhere near an edge. That is true of the clipping but misses the point: it left the
	 * kinds of row behaving differently, so SET-42's toggles opened upward while the field
	 * beside them opened left. A help icon should not change direction depending on which control
	 * it belongs to.
	 *
	 * THERE ARE THREE ROW CLASSES, NOT TWO - found on Maxx Reach, 26 Oct 2026. A labelled toggle
	 * puts its words in a sibling .my-settings-field-toggle-cell; an unlabelled one keeps the
	 * switch and its words together in .my-settings-field-toggle, so naming only the -cell class
	 * repeated the same split one level down. "Turn on Maxx Reach" opened upward while the three
	 * selects under it opened left, on one panel, in view of each other. Seven icons were affected:
	 * Maxx Reach, Maxx Assist (2), Shortcuts, Task Manager and CP|central General (2) - counted by
	 * MySettingsTooltipPlacementTest's sweep, not by eye.
	 *
	 * STILL NOT EVERY TOOLTIP ON THE SURFACE. Cards, stat lists and table rows put icons close to
	 * the panel's left margin, where opening left is the same bug facing the other way. This names
	 * the three field-row classes and leaves those alone.
	 *
	 * @param  object $scope jQuery element to search within.
	 *
	 * @return void
	 */
	_placeFieldTooltips = function placeFieldTooltips($scope)
	{
		$scope.find('.my-settings-field-control [data-toggle^="tooltip"], '
			+ '.my-settings-field-toggle-cell [data-toggle^="tooltip"], '
			+ '.my-settings-field-toggle [data-toggle^="tooltip"]')
			.attr('data-placement', 'left');
	};

	_sizeTextareas = function sizeTextareas($scope)
	{
		var $autoheight;

		if (!$scope || typeof Adzuki.TextareaAutoheight !== 'function') {
			return;
		}

		$autoheight = $scope.find('textarea.autoheight');

		if (!$autoheight.length) {
			return;
		}

		$autoheight.css('height', 'auto');

		Adzuki.TextareaAutoheight($autoheight);
	};

	/**
	 * Wires the freshly injected markup.
	 *
	 * form.js only initialises forms at document ready, so an injected form would post without
	 * form_component_attribute_data and surface from FormComponent as "Missing form attribute
	 * data" - an error that reads like a form bug and is nowhere near its cause.
	 * initAjaxForm() is the framework's own seam for exactly this and also re-runs the form's
	 * load(). Tooltips need no such call: _global.js delegates them from <body> with a
	 * selector, so injected content picks them up on its own.
	 */
	/**
	 * SET-149: is the nav drawer open? Always false above the breakpoint, where the class is
	 * never set and the CSS ignores it anyway.
	 */
	_navIsOpen = function navIsOpen()
	{
		return ($overlay !== null && $overlay.find('.my-settings-shell').hasClass('is-nav-open'));
	};

	/**
	 * Opens or closes the nav drawer, moving focus with it.
	 *
	 * FOCUS GOES INTO THE DRAWER ON OPEN AND BACK TO THE TOGGLE ON CLOSE. Without the first, a
	 * keyboard user opens the drawer and is still standing in the top bar, several tab stops
	 * away from what they just revealed. Without the second, closing it leaves focus on an
	 * element that is now invisible, and the next Tab starts from the top of the dialog.
	 *
	 * It does NOT run on a navigation: the render replaces the shell, the drawer closes with it,
	 * and SET-148's heading focus is the right landing place from there.
	 *
	 * @param {boolean} open
	 */
	_setNavOpen = function setNavOpen(open)
	{
		var $shell, $toggle, $nav;

		if ($overlay === null) {
			return;
		}

		$shell  = $overlay.find('.my-settings-shell');
		$toggle = $overlay.find('[data-my-settings-nav-toggle]');

		$shell.toggleClass('is-nav-open', Boolean(open));
		$toggle.attr('aria-expanded', (open ? 'true' : 'false'));

		if (open) {
			// SET-149 AC 8: FLUSH THE STYLE CHANGE BEFORE MOVING FOCUS.
			//
			// The closed drawer is `visibility: hidden` - deliberately, so its links are out
			// of the tab order rather than merely off screen - and `visibility` sits in its
			// transition list so the slide-out stays visible on the way closed.
			//
			// Adding is-nav-open only marks the style DIRTY. At the instant the next line ran,
			// the drawer's computed visibility was still hidden - and an element that is not
			// visible cannot take focus, so .focus() was a silent no-op and focus stayed on the
			// toggle with aria-expanded already reading true. That is exactly what QA caught:
			// document.activeElement = button.my-settings-nav-toggle.
			//
			// Reading a computed style forces the recalculation. The returned value is not
			// wanted; the READ is the whole point of the line.
			//
			// QA ROUND 3: THAT WAS NECESSARY AND IT WAS NOT SUFFICIENT, and the line stays only
			// because the other half now makes it work. A transition on `visibility` is a
			// DISCRETE step whose value at progress 0 is still the START value - so recalculating
			// the style computed `hidden`, because the recalculation happens at the instant the
			// transition begins and that instant is progress 0. The flush was reading the right
			// property at the only moment it still said the wrong thing.
			//
			// The fix is in the stylesheet: `visibility` now switches with zero duration, delayed
			// on close and immediate on open. Written up at the drawer rules in
			// scss/component/_my_settings.scss, because that is where the mistake was.
			//
			// NOT a setTimeout: the focus belongs to the gesture that opened the drawer, and a
			// deferred one can be overtaken by whatever the advisor does next. Nor a
			// transitionend listener - it does not fire when there is no transition to end, which
			// is every reduced-motion user and would have traded this bug for its mirror image.
			$nav = $shell.find('.my-settings-nav');

			$nav.css('visibility');

			$nav.find('a, input').first().focus();

			return;
		}

		$toggle.focus();
	};

	/**
	 * SET-148 AC 1: REPLACES WHAT IS INSIDE THE DIALOG, KEEPING THE DIALOG ELEMENT ITSELF.
	 *
	 * The response is the whole overlay, .my-settings-modal[role=dialog] included, so
	 * $overlay.html() destroyed and rebuilt that element on every panel navigation. To a screen
	 * reader a role="dialog" that was not there a moment ago is a dialog the user has just
	 * ENTERED: Narrator announces it and starts reading its content from the top, and the nav is
	 * first in DOM order - so the advisor heard the left menu again instead of the panel.
	 *
	 * ROUND ONE'S HEADING FOCUS WAS RIGHT AND IS KEPT; it could not fix this by itself. The
	 * re-announcement is not about where focus lands, it is about the dialog being a different
	 * element than it was. QA's capture shows the two separately: "My Settings dialog" (entered),
	 * "CP|central heading level 2" (the new focus, working as intended), then "Settings sections"
	 * (reading restarted at the top regardless).
	 *
	 * THE SHELL INSIDE IS STILL REPLACED WHOLESALE, and two things depend on that: SET-149's nav
	 * drawer closes for free because is-nav-open is a class on the shell, and the nav is rebuilt
	 * so the current section marks correctly. Only the dialog element outlives the swap.
	 *
	 * Parsed once and MOVED rather than re-serialised, so an inline script in a panel would run
	 * exactly once. No panel carries one today; this costs nothing and removes the question.
	 *
	 * Falls back to a whole-overlay swap whenever there is no KEEPABLE dialog on one side or the
	 * other: the opening fetch, where the overlay still holds the loading placeholder, and any
	 * render that follows a failed one.
	 *
	 * THE ERROR MARKUP IS NOT A DIALOG TO KEEP, and excluding it closes a hole round two opened.
	 * _errorMarkup() emits .my-settings-modal so that _afterRender() can fall back to it for
	 * focus - which also made it match the selector below, so a panel rendered AFTER an error was
	 * appended INTO the error box and inherited its 480px centred styling. That is reachable: the
	 * error offers "Open them on their own page instead", the href carries no target, and the
	 * containment handler turns it into a panel fetch - so one succeeding retry put the whole
	 * modal inside the failure message.
	 *
	 * Falling back to a whole-overlay swap there is also the RIGHT reader behaviour. The advisor
	 * really was in a different dialog a moment ago, so announcing the one they have arrived in
	 * is accurate rather than the spurious re-entry this function exists to stop.
	 *
	 * QA ROUND 3: AND THE SWAP ITSELF MUST NOT STEP THROUGH <body> ON THE WAY PAST.
	 *
	 * Keeping the dialog element was necessary and was not sufficient. `.empty()` destroyed the
	 * nav link the advisor had just clicked WHILE IT STILL HELD FOCUS, so document.activeElement
	 * became <body> - outside the dialog - and the focus call that lands on the new heading is a
	 * separate statement after it.
	 *
	 * THAT IS WHY IT READ AS INTERMITTENT RATHER THAN AS BROKEN. Both statements run in one task
	 * with no paint between them, so whether the reader observes the momentary step outside is a
	 * race. QA caught both outcomes on two consecutive tries of the same click: once "My Settings
	 * dialog, CP|central heading level 2" and then scan back to "heading level 1 My Settings,
	 * Search Settings" - the dialog re-entered and its virtual cursor reset to the top - and once
	 * a clean landing, with Down arrow reading "General tab item, 1 of 3" inside the panel.
	 *
	 * So the order is APPEND, FOCUS, THEN REMOVE. The incoming content is in the dialog before
	 * the outgoing content leaves it, focus moves from the old element straight to the new
	 * heading, and at no instant is it anywhere but inside this dialog. The two sets overlap for
	 * the length of one focus call, during which nothing queries the DOM and nothing is painted.
	 *
	 * _afterRender() still names the landing target for the paths that do not come through here -
	 * the opening fetch and the error render - and re-focusing an element that already has focus
	 * is a no-op, so the two do not fight over it.
	 */
	_swapPanel = function swapPanel(html)
	{
		var $dialog = $overlay.find('.my-settings-modal').not('.my-settings-modal-error').first(),
		    $incoming,
		    $outgoing,
		    $added,
		    $landing;

		if ($dialog.length === 0) {
			$overlay.html(html);

			return;
		}

		$incoming = $($.parseHTML(html, document, true)).filter('.my-settings-modal').first();

		if ($incoming.length === 0) {
			$overlay.html(html);

			return;
		}

		$outgoing = $dialog.contents();
		$added    = $incoming.contents();

		$dialog.append($added);

		// scoped to the INCOMING nodes: the outgoing panel still carries a heading of its own and
		// comes first in DOM order, so a search across the dialog would land on the one that is
		// about to be destroyed.
		$landing = $added.find('.my-settings-panel-title').first();

		if ($landing.length === 0) {
			$landing = $dialog;
		}

		$landing.focus();

		$outgoing.remove();
	};

	_afterRender = function afterRender()
	{
		var $landing;

		$overlay.find('form[data-form-component]').each(function initInjectedForm() {
			var name = $(this).attr('name');

			if (name && Adzuki.Form && typeof Adzuki.Form.initAjaxForm === 'function') {
				Adzuki.Form.initAjaxForm(name);
			}
		});

		_sizeTextareas($overlay);

		_placeFieldTooltips($overlay);

		// SET-32: THE VISUAL LIST LINK BINDS ITSELF ONLY IF ONE WAS ON THE PAGE AT DOCUMENT READY.
		// visual_list.js calls its own init() from $(document).ready guarded on `.visual-list`
		// existing, so a link that arrives with a panel is never wired and the picker does nothing.
		// init() is idempotent - it does .off() before .on() and binds to the elements themselves -
		// so calling it per render cannot stack handlers.
		if (Adzuki.VisualList && typeof Adzuki.VisualList.init === 'function'
			&& $overlay.find('.visual-list').length) {
			Adzuki.VisualList.init();
		}

		// SET-148: FOCUS THE PANEL'S OWN HEADING, NOT THE DIALOG.
		//
		// Focus has to move somewhere inside the overlay after a render - the element that had
		// it has just been replaced, and letting focus fall to <body> would put the advisor
		// outside the dialog, breaking the Tab trap and leaving ESC with nothing to act on.
		//
		// It used to go to .my-settings-modal, the dialog container itself. To a screen reader
		// that reads as ENTERING the dialog: Narrator announced it and started reading from the
		// top of its content, which is the nav - so after clicking a section the advisor heard
		// the left menu again instead of the panel. QA captured it on 6 Oct 2026.
		//
		// The heading carries the subsection name, so landing there announces WHERE the advisor
		// just arrived and then reads on into the panel. The dialog stays the fallback for the
		// two renders that have no heading: the error markup, and a panel with no position.
		$landing = $overlay.find('.my-settings-panel-title').first();

		if (!$landing.length) {
			$landing = $overlay.find('.my-settings-modal').first();
		}

		$landing.focus();

		// AFTER the focus call, not before: focusing an element scrolls it into view, so a
		// restore that ran first would be undone by it.
		if (panel_scroll !== null) {
			$overlay.find('.my-settings-body').scrollTop(panel_scroll);

			panel_scroll = null;
		}

		// Restored after the focus call for the same reason the panel body is - focusing an
		// element scrolls its ancestors to bring it into view, so a restore that ran first would
		// be undone by it.
		if (nav_scroll) {
			$overlay.find('.my-settings-nav-scroll').scrollTop(nav_scroll);
		}

		// SET-12 snapshots entry state from here. An event rather than a direct call so the
		// overlay does not have to know what else cares that a panel arrived.
		$(document).trigger('my-settings:rendered');
	};

	/**
	 * SET-123: shows one pane of a form group and hides its siblings.
	 *
	 * HIDES BY CLASS, AND NOTHING HERE DISABLES ANYTHING. A disabled input does not post, so
	 * disabling the pane the advisor is not looking at would produce exactly the partial
	 * payload this mechanism exists to prevent - and it would fail validation rather than
	 * silently, because the server validates a field absent from the payload as null.
	 *
	 * It also moves the panel url, so the panel re-render that follows a save comes back on
	 * the tab the advisor is actually on rather than the one they arrived on.
	 *
	 * @param  string key Tab key, as declared in MySettingsNavComponent.
	 *
	 * @return boolean Whether a pane by that key was found.
	 */
	_showPane = function showPane(key)
	{
		var $panes,
		    $target,
		    $tab,
		    url;

		if ($overlay === null || !key) {
			return false;
		}

		$panes  = $overlay.find('.my-settings-pane');
		$target = $panes.filter('[data-pane="' + key + '"]');

		// an ungrouped panel has no panes at all, which is the normal case
		if ($target.length === 0) {
			return false;
		}

		$panes.removeClass('is-current').attr('aria-hidden', 'true');
		$target.addClass('is-current').removeAttr('aria-hidden');

		// The pane was display:none until the line above, so anything whose size depends on being
		// laid out has to be measured NOW rather than at render.
		_sizeTextareas($target);

		$overlay.find('.my-settings-tab').removeClass('is-current');
		$overlay.find('[data-my-settings-pane]').attr('aria-selected', 'false');

		$tab = $overlay.find('.my-settings-tab[data-pane="' + key + '"]');

		$tab.addClass('is-current');
		$tab.find('[data-my-settings-pane]').attr('aria-selected', 'true');

		// the breadcrumb carries the tab (SET-9), so it has to move with it
		$overlay.find('.my-settings-crumb-current').text($.trim($tab.text()));

		url = $tab.find('[data-my-settings-url]').attr('data-my-settings-url');

		if (url) {
			panel_url = url;

			// SET-17: THE FORM POSTS TO THE TAB ON SCREEN, and moving panel_url alone was not
			// enough to make that true.
			//
			// $Form->create() takes its action from the uri the PANEL was fetched at, and a pane
			// switch is client-side - so after switching to Certs & Social the form still posted
			// to /MySettings/myProfile. MySettingsPersistenceComponent then returns that uri as
			// where to go next, the save handler sees a target that differs from panel_url, and
			// treats it as SET-60's "the server named another panel" case: it navigates there.
			// The advisor saved from the second tab and landed back on the first.
			//
			// Repointing the action fixes both halves at once - the post goes to the action whose
			// render marks this tab current, and target and panel_url agree again, so the save
			// handler takes the re-render path and keeps the scroll position with it.
			//
			// SAFE BECAUSE THE GROUP IS ONE SAVE UNIT. Every tab in it is backed by the same form
			// and every action renders the same view; which one receives the post decides only
			// which tab comes back current.
			$overlay.find('form[data-form-component]').attr('action', _resolve(url));
		}

		// NOTHING LISTENS TO THIS TODAY, and it is kept deliberately. The save module used it to
		// repaint the per-tab modified markers, which were removed on 8 Sep 2026; the event is
		// the seam for anything that needs to know which pane is showing - the in-modal search
		// scrolling to an anchor on a pane being the likely next one - and an event nobody
		// handles costs nothing, whereas discovering later that the switch is unobservable costs
		// a change to this file.
		// SET-148 AC 2: MOVE THE READER INTO THE PANE THE ADVISOR JUST ASKED FOR.
		//
		// A pane switch is client-side, so nothing is destroyed and focus stays on the tab
		// button. A screen reader therefore announced the tab and stopped - QA heard
		// "Notifications tab item, 2 of 3, selected" and then silence, with none of the content
		// that switching to it was for. Round one only ever moved focus on a RENDER, and this
		// path does not render.
		//
		// The pane is the right landing place rather than the heading: the heading names the
		// SUBSECTION and does not change between tabs, so re-announcing it would say nothing new
		// and then read the whole panel from the top again. role="tabpanel" plus the tab as its
		// label means landing here announces which tab is open and reads on into its fields.
		//
		// tabindex="-1" on the pane, so this is a focus TARGET and never a Tab stop - FOCUSABLE
		// at the top of this file excludes [tabindex="-1"], so the trap is unaffected.
		//
		// AFTER the form action is repointed above, so nothing moves under the advisor between
		// landing and reading.
		$target.focus();

		$(document).trigger('my-settings:paneswitched', [key]);

		return true;
	};

	/**
	 * Replaces the framework's failure lead-in with one that claims nothing about the save.
	 *
	 * SET-90 AC 5. form.js prefixes every reported failure with "The form could not be
	 * submitted for the following reason(s):" - which is true of most forms in the app and is
	 * a LIE on the W9. FranchiseTaxInfoManageForm::process() writes the records and then sends
	 * the emails, inside one try/catch and with no transaction, so a mail failure surfaces an
	 * error with the W9 already filed. Telling the advisor it could not be submitted invites a
	 * second submission of a signed tax document, which is worse than the failure that
	 * prompted it.
	 *
	 * THE MESSAGES THEMSELVES ARE ALREADY RIGHT and are not touched: process() reports "There
	 * was a problem creating the W9", "Your file failed to upload. Here's why: ..." and
	 * whatever the mailer threw - each naming its own step. Only the sentence wrapped around
	 * them asserts something about the whole operation, so only that is replaced, with a lead-in
	 * that reports and does not conclude.
	 *
	 * SCOPED TO THE MODAL BEING OPEN, and restored on close. Every form on every other screen
	 * keeps the framework's copy, which is correct for them - a form whose process() is one
	 * write really did not submit.
	 */
	_installErrorCopySeam = function installErrorCopySeam()
	{
		if (!Adzuki.Form || typeof Adzuki.Form.throwSubmissionError !== 'function') {
			return;
		}

		// INSTALLED ONCE. open() runs on every launch and _showPane() re-renders inside one
		// session; wrapping a wrapper would stack lead-ins.
		if (_frameworkThrowSubmissionError !== null) {
			return;
		}

		_frameworkThrowSubmissionError = Adzuki.Form.throwSubmissionError;

		Adzuki.Form.throwSubmissionError = function neutralLeadIn(custom_error_message)
		{
			if ($overlay === null) {
				_frameworkThrowSubmissionError(custom_error_message);
				return;
			}

			Adzuki.StatusMessage('Error', 'The following was reported:<br><br>' + custom_error_message);
		};
	};

	/**
	 * Stops a successful save from navigating the host page away.
	 *
	 * form.js answers a save it does not recognise as an error by assigning
	 * window.location.href to the location the form returned - which is right for a
	 * standalone screen and fatal for a modal: the save works, and the advisor is thrown
	 * out onto the bare settings page with the CP|central page they were working on gone.
	 * Without this, SET-8's own AC 11 and AC 12 are unreachable, because there would be no
	 * modal left to close after a save.
	 *
	 * THIS IS A GUARD RAIL, NOT THE SAVE UX. It keeps the modal alive and re-renders the
	 * panel from the server, so the advisor sees the saved values. What it does not do is
	 * tell them the save succeeded - the status indicator is SET-74, the top-bar Save
	 * button is SET-75 and the per-subsection save flow is SET-12. form.js still owns the
	 * POST, the validation and the attribute map, so nothing here hand-rolls a submit
	 * (S15).
	 *
	 * Scoped to forms inside the overlay, so a save anywhere else keeps the framework's
	 * behaviour untouched.
	 */
	/**
	 * SET-43: turns a form's partial-failure summary into one sentence for the status bar.
	 *
	 * NUMBERS RATHER THAN A LIST. The summary also carries each failure's message, but the top bar
	 * is one line and those messages come from an external service - so the count is what the
	 * advisor can act on, and "3 of 23" says both that it mostly worked and that it did not
	 * entirely.
	 *
	 * @param  object summary total and failed, from the form.
	 *
	 * @return string
	 */
	_partialMessage = function partialMessage(summary)
	{
		var failed = parseInt(summary.failed, 10),
		    total  = parseInt(summary.total, 10);

		if (!failed) {
			return null;
		}

		if (!total) {
			return 'Saved \u2014 some flight alerts were not updated';
		}

		// ALL OF THEM FAILING IS NOT A PARTIAL FAILURE OF THE BULK UPDATE - it is a total one, and
		// "12 of 12 were not updated" makes the reader do that arithmetic to find out. The SAVE is
		// still a save, which is why this is not the 'failed' state: the settings are stored and
		// only the retroactive pass came back empty-handed.
		if (failed >= total) {
			return 'Saved \u2014 none of your ' + total + ' upcoming air bookings could be updated';
		}

		return 'Saved \u2014 ' + failed + ' of ' + total + ' flight alerts were not updated';
	};

	_installRedirectSeam = function installRedirectSeam()
	{
		if (!Adzuki.Form) {
			return;
		}

		Adzuki.Form.onSuccessRedirect = function keepModal(form_element, response) {
			var target  = ((response && typeof response.data === 'string') ? response.data : null),
			    resumed = false;

			if ($overlay === null || $.contains($overlay[0], form_element) === false) {
				return true;
			}

			// SET-43: A SAVE CAN SUCCEED AND STILL HAVE HALF-FAILED.
			//
			// The settings are stored either way; what can partly fail is a side effect reaching
			// outside the application - the retroactive flight-alert update issues one external call
			// per future air reservation. The form reports that in a 'partial' key on the result,
			// because the session flash it uses for the legacy screen is deleted by
			// MySettingsPersistenceComponent before this ever runs (S37).
			if (
				response && response.partial
				&& Adzuki.MySettings.Save && typeof Adzuki.MySettings.Save.partial === 'function'
			) {
				resumed = Adzuki.MySettings.Save.partial(_partialMessage(response.partial));
			} else if (Adzuki.MySettings.Save && typeof Adzuki.MySettings.Save.succeeded === 'function') {
				resumed = Adzuki.MySettings.Save.succeeded();
			}

			// SET-12: SAVE AND CONTINUE HAS ALREADY NAVIGATED, SO NOTHING BELOW MAY NAVIGATE AGAIN.
			//
			// The call above resumes the deferred action when the advisor chose Save and continue -
			// load() for a subsection switch, close() for a dismissal. Falling through from there put
			// a SECOND fetch in flight: the re-render at the foot of this function asks for panel_url,
			// which is still the panel being LEFT because _fetch() only moves it when its own response
			// lands. Two GETs, and whichever answered last won.
			//
			// That is exactly what QA saw on 1 Oct 2026 - My Shortcuts flashing up and Invoice Settings
			// coming back - and why it was intermittent rather than broken: the destination was fetched
			// first, so it usually lost. Closing was never affected because close() nulls the overlay
			// and every fetch callback checks that first.
			//
			// The advisor's own choice wins over the server's return route, which is the right way
			// round: they clicked a destination and then asked to save on the way there.
			if (resumed === true) {
				return false;
			}

			// SET-60: THE SERVER CAN NAME WHERE TO GO NEXT, and when it names another panel in
			// this modal, go there.
			//
			// A sub-screen is the case it exists for: saving a shipping account should return the
			// advisor to the list they came from, not leave them on the form they just finished.
			// MySettingsPersistenceComponent rewrites a form's own legacy return route to the
			// current url, so an ordinary panel still lands here saying "stay put" and nothing
			// about the existing behaviour changes.
			//
			// Both sides are resolved before comparing, because the two sources disagree about the
			// base uri: a link built by HtmlComponent arrives prefixed and a data-my-settings
			// attribute arrives bare, so the same panel can be spelled two ways.
			if (
				target !== null
				&& target.indexOf('/MySettings/') !== -1
				&& _resolve(target) !== _resolve(panel_url)
			) {
				settings.load(target);

				return false;
			}

			// SET-26: AN ABSOLUTE URL IS A DELIBERATE EXIT, and the modal must not swallow it.
			//
			// The guard above exists because a form's own return route points at the legacy
			// screen it used to live on, and following that throws the advisor out of a page
			// they were working in. MySettingsPersistenceComponent rewrites those to the current
			// url, so an ordinary save never reaches here with anything else.
			//
			// What it leaves alone is an absolute url, which is a form saying "leave this app"
			// rather than a stale route: a first MFA confirmation ends the session and returns
			// /main/logout (S42). Staying put there would leave the advisor in a modal behind a
			// session that no longer exists.
			if (target !== null && (/^https?:\/\//i).test(target)) {
				window.location.href = target;

				return false;
			}

			// SET-58: KEEP THE PANEL WHERE THE ADVISOR LEFT IT. The re-render below replaces the
			// overlay's markup wholesale, so the body scrolls back to the top - which on a panel
			// as long as Franchise Profile threw them from the toggle they had just saved up to a
			// pair of read-only cards. Nothing about a save asks to move the viewport.
			settings.load(panel_url, true);

			return false;
		};
	};

	/**
	 * Decision S37 - whether closing the modal has to redraw the page behind it.
	 *
	 * Asked of the server rather than counted here, because a shell-affecting write can happen
	 * where this file cannot see it: the shortcuts endpoints are their own requests, and
	 * saveExpandedMenus() writes display_navigation_shortcuts as a side effect of expanding a
	 * menu. The failure that matters is a stale shell, so the authority sits where every write
	 * is visible. The overlay is already gone by the time this runs, so the common answer -
	 * no - costs the advisor nothing.
	 */
	_reloadIfShellChanged = function reloadIfShellChanged()
	{
		$.getJSON(Adzuki.base_uri + '/MySettings/shellState', function shellState(response) {
			if (response && response.reload === true) {
				window.location.reload();
			}
		});
	};

	/**
	 * Opens the modal over the current page.
	 *
	 * @param  string url     Panel to open on, e.g. /MySettings/aiSettings
	 * @param  object trigger Element that opened it; focus returns here on close.
	 */
	/**
	 * @param string  url          Panel to open.
	 * @param element trigger      What opened it, to return focus to on close.
	 * @param string  fallback_url SET-165: panel to fall back to if `url` cannot be fetched.
	 *                             Passed only where the panel came from untrusted input - see
	 *                             the error branch of _fetch().
	 */
	settings.open = function open(url, trigger, fallback_url)
	{
		if ($overlay !== null) {
			settings.load(url);

			return;
		}

		$opener = (trigger ? $(trigger) : null);

		_lock();

		// SET-148 QA round 3: the page behind goes inert BEFORE the overlay is appended, so the
		// overlay is not one of the children that marks.
		_hideBackground();

		$overlay = $('<div>', { class: 'my-settings-overlay' })
			.html('<div class="my-settings-loading" role="status" tabindex="-1"'
				+ ' aria-label="Loading your settings">Loading your settings&hellip;</div>')
			.appendTo('body');

		// SET-148 QA round 3: FOCUS HAS TO LAND SOMEWHERE, AND IT CANNOT STAY WHERE IT WAS.
		//
		// Whatever opened the modal is inside the subtree just marked inert, so the browser blurs
		// it and focus falls to <body> - outside the overlay, with aria-hidden now over
		// everything else in the document, which is the one combination a reader has nothing at
		// all to say about. The placeholder already carries role="status" and already says what
		// is happening, so it is both the nearest valid target and the one worth announcing.
		//
		// QA ROUND 4: AND IT NEEDS aria-label TO SAY ANY OF THAT. role="status" is not a
		// name-from-content role, so the element had NO accessible name and focusing it announced
		// the bare role - QA heard "status" and nothing else. The visible text stays for everyone
		// reading the screen; the label is what a reader announces on arrival.
		$overlay.find('.my-settings-loading').focus();

		_bind();

		_installRedirectSeam();
		_installErrorCopySeam();

		_fetch(url, true, fallback_url);
	};

	/**
	 * Swaps the panel without touching the overlay, the scroll lock or the session.
	 *
	 * @param string  url         Panel to load.
	 * @param boolean keep_scroll Hold the panel's scroll offset across the render. For a
	 *                            RE-render of the same panel - after a save - where the
	 *                            advisor has not asked to go anywhere. Panel NAVIGATION
	 *                            deliberately does not pass it: arriving somewhere new starts
	 *                            at the top.
	 */
	settings.load = function load(url, keep_scroll)
	{
		if ($overlay === null) {
			return;
		}

		panel_scroll = (keep_scroll ? $overlay.find('.my-settings-body').scrollTop() : null);

		_fetch(url, false);
	};

	settings.isOpen = function isOpen()
	{
		return $overlay !== null;
	};

	settings.currentUrl = function currentUrl()
	{
		return panel_url;
	};

	/**
	 * SET-123. Public so the save module can reveal the pane that owns a validation error -
	 * an error reported against a field nobody can see is worse than no error at all.
	 */
	settings.showPane = function showPanePublic(key)
	{
		return _showPane(key);
	};

	/**
	 * Registers the leave guard.
	 *
	 * THIS IS SET-76'S SEAM. Every dismissal path - X, ESC and the backdrop - goes through
	 * requestClose(), so the discard-confirmation dialog is registered once here rather than
	 * intercepted three times.
	 *
	 * The guard is handed an action - { source, url } where source is 'button', 'escape',
	 * 'backdrop' or 'nav' - and returns true when it is safe to proceed. Anything else means
	 * the guard has taken over and will complete or abandon the action itself.
	 *
	 * IT GUARDS NAVIGATION AS WELL AS DISMISSAL. SET-12 prompts on a subsection switch for
	 * the same reason it prompts on close - the edits are equally lost either way - so the
	 * in-modal link handler routes through here rather than calling load() directly.
	 *
	 * With no guard registered, every dismissal and every navigation proceeds immediately.
	 */
	settings.registerGuard = function registerGuard(fn)
	{
		guard = fn;
	};

	settings.requestClose = function requestClose(source)
	{
		var action = {
			source: source,
			url   : null
		};

		if (typeof guard === 'function' && guard(action) !== true) {
			return false;
		}

		settings.close();

		return true;
	};

	/**
	 * Moves to another panel, asking the guard first.
	 */
	settings.requestNavigate = function requestNavigate(url)
	{
		var action = {
			source: 'nav',
			url   : url
		};

		// SET-149: CLOSE THE DRAWER BEFORE THE GUARD RUNS, not after the navigation lands.
		//
		// Choosing a section normally closes it for free, because the render replaces the shell
		// the open state lives on. But a DIRTY panel never gets that far: the guard raises the
		// discard dialog and returns, so no render happens - and Keep editing then put the
		// advisor back on the panel they were editing with the drawer and scrim still over it.
		//
		// Closing here covers all three answers at once. Keep editing returns to a clear panel;
		// Discard and Save and continue navigate, where the drawer would have gone anyway.
		if (_navIsOpen()) {
			_setNavOpen(false);
		}

		if (typeof guard === 'function' && guard(action) !== true) {
			return false;
		}
		settings.load(url);

		return true;
	};

	/**
	 * Closes the modal unconditionally. Dismissal paths call requestClose() instead.
	 */
	settings.close = function close()
	{
		if ($overlay === null) {
			return;
		}

		$overlay.remove();
		$overlay  = null;
		panel_url = null;

		if (Adzuki.Form) {
			Adzuki.Form.onSuccessRedirect = null;

			if (_frameworkThrowSubmissionError !== null) {
				Adzuki.Form.throwSubmissionError = _frameworkThrowSubmissionError;
				_frameworkThrowSubmissionError   = null;
			}
		}

		_unlock();

		// SET-148 QA round 3: BEFORE the opener is focused, not after - see _showBackground().
		_showBackground();

		if ($opener !== null && $opener.length) {
			_restoreFocus($opener);
		}

		$opener = null;

		// SET-74: the save state belongs to the modal session, not to the page load. Announced
		// rather than reset from here, so this file does not have to know what the save module
		// keeps.
		$(document).trigger('my-settings:closed');

		_reloadIfShellChanged();
	};

	$(document).ready(function documentReady() {
		// Any element carrying data-my-settings opens the modal on the panel that attribute
		// names, and its href stays the working fallback when this script has not run. The
		// CP|central sidebar entry is wired that way in CpcentralNavComponent; SET-10 turns the
		// legacy URLs themselves into modal opens.
		$(document).on('click', '[data-my-settings]', function openFromLink(e) {
			var url = $(this).attr('data-my-settings');

			if (!url) {
				return;
			}

			e.preventDefault();

			// SET-141: INSIDE AN OPEN MODAL THIS IS NAVIGATION, AND NAVIGATION ASKS THE GUARD.
			//
			// open() delegates to load() when the overlay already exists, and load() fetches
			// immediately - so a link carrying this attribute walked straight past the unsaved-changes
			// dialog. It did not matter while the attribute lived only on the CP|central header and
			// sidebar, where nothing is dirty because no panel is open yet; the LivePlanner tab's link
			// to its blackout sub-screen is the first one INSIDE a panel, and it could leave an edited
			// panel without asking.
			//
			// requestNavigate() is the seam SET-8 left for exactly this - the same one the nav and the
			// tab strip use - so every in-modal navigation now goes through one door.
			if (settings.isOpen()) {
				settings.requestNavigate(url);

				return;
			}

			Adzuki.MySettings.open(url, this);
		});

		$(document).on('keydown', function escapeKey(e) {
			if (e.which !== 27 || $overlay === null) {
				return;
			}

			// A framework dialog opened from inside a panel lands in the host page's
			// #modalWindow, which sits above this overlay. Bootstrap closes that one on ESC;
			// closing the settings modal out from under it would leave the dialog stranded
			// over a page it no longer belongs to.
			//
			// SET-180: THE SECOND TEST IS NOT REDUNDANT, AND THE FIRST ONE ALONE IS A FLAG READ
			// AFTER SOMEBODY ELSE CLEARED IT.
			//
			// Bootstrap binds its own ESC on #modalWindow itself (Modal.prototype.escape), and
			// hide() removes the `in` class SYNCHRONOUSLY. This handler is on document, so a key
			// pressed inside the dialog reaches Bootstrap first and arrives here with `in` already
			// gone - the guard then waves it through and closes the settings modal out from under
			// the dialog it was written to protect.
			//
			// It never fired before SET-180 because the dialog was inert and could not hold focus,
			// so ESC was always pressed in the overlay and never passed through #modalWindow at all.
			// Making the dialog usable is what exposed it.
			//
			// So: the class test covers a dialog that is open while focus is elsewhere, and the
			// origin test covers the dialog having just handled this very keystroke. Neither one
			// covers both cases.
			if ($('#modalWindow').hasClass('in') || $(e.target).closest('#modalWindow').length > 0) {
				return;
			}

			// SET-149: ESC BELONGS TO THE DRAWER FIRST. It is the innermost thing the advisor
			// opened, and closing the whole modal out from under an open drawer would discard
			// work to dismiss a menu. One ESC shuts the drawer, a second closes the modal.
			if (_navIsOpen()) {
				_setNavOpen(false);

				return;
			}

			settings.requestClose('escape');
		});
	});

	Adzuki.MySettings = settings;
}(jQuery, window.Adzuki || {}));
